export default class PasswortUpdateRequest {
  neuesPasswort: string
  randomLink: string
}
